/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-30 11:33:57
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-08 15:14:04
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelLegal/TermsAndConditionEditor/common.ts
 */
import {
  common,
  defaultStatus,
  generateCollapseOpen,
} from 'src/pages/SalesCannelVersion/SalesChannelLegal/slice/common';

enum EnumCollapseId {
  PageSetting = 'PageSetting',
  LegalSetting = 'LegalSetting',
  Content = 'Content',
}

const generatePageSetting = () => {
  return { name: '', isNameDuplicate: false, remarks: '', nameIsValid: true };
};

const generateLegalSetting = () => {
  return {
    setAgreementAsRequired: false,
    defaultStatusChecked: false,
  };
};

const generateContent = () => {
  return { content: '', isEmpty: true };
};

export {
  generateContent,
  generateLegalSetting,
  generatePageSetting,
  EnumCollapseId,
  common,
  generateCollapseOpen,
  defaultStatus,
};
